'use client';

import { useParams } from 'next/navigation';
import React, { FC } from 'react';

import { NewsType } from '@/api/config/types';
import Image from '@/components/core/Image';
import Link from '@/components/core/Link';
import { useTranslation } from '@/hooks/useTranslations';
import './styles.scss';

const NewsItem: FC<NewsType> = ({ logo, date, title, slug, alt }) => {
  const params = useParams();
  const { t } = useTranslation();
  return (
    <div className="newsContentBox">
      <Link href={`/${params.lang}/news/${slug}`} className="newsBoxImgCont">
        <div className="newsBoxImgContInner">
          <Image alt={alt || 'news'} src={logo} width={500} height={500} className="newsBoxImg" />
        </div>
      </Link>
      <div className="newsBoxTitleWrp">
        <p className="newsBoxTitleText">{title}</p>
        <span className="newsBoxDateText">{date}</span>
      </div>
      <Link href={`/${params.lang}/news/${slug}`} className="newsBoxBottomRow">
        <p className="newsBoxBottomText">{t('Poly-News&updates-button')}</p>
        <i className="bc-i-arrow-right newsIcon" />
      </Link>
    </div>
  );
};

export default NewsItem;
